__webpack_require__.p = "https://cdn.n-tv.de/sport/0.95.1/_next/";